import { AgentType } from "build-ts/agent";
import { DarwinToolType } from "build-ts/darwin_agent";
import { DarwinAgentType } from "build-ts/common";


// Model options with their corresponding types
export const modelOptions = {
    openai: [
      "gpt-5",
      "gpt-5-mini",
      "gpt-4o",
      "gpt-5.1"
    ],
    anthropic: [
      "claude-opus-4-1-20250805",
      "claude-opus-4-20250514",
      "claude-sonnet-4-20250514",
      "claude-3-7-sonnet-20250219",
      "claude-3-5-haiku-20241022",
      "claude-3-haiku-20240307"
    ],
    azure_openai: [
      "gpt-4o",
      "gpt-4o-mini",
      "gpt-4-turbo",
      "gpt-4",
      "gpt-35-turbo",
      "o1-preview",
      "o1-mini"
    ],
    azure_ai: [
      "phi-3-medium-128k-instruct",
      "phi-3-mini-128k-instruct",
      "phi-3-small-128k-instruct"
    ],
    google_vertexai: [
      "claude-opus-4-1@20250805",
      "claude-opus-4@20250514",
      "claude-sonnet-4@20250514",
      "claude-3-7-sonnet@20250219",
      "claude-3-5-haiku@20241022",
      "claude-3-haiku@20240307"
    ],
    google_genai: [
      "gemini-2.0-flash",
      "gemini-2.0-flash-preview",
      "gemini-1.5-pro",
      "gemini-1.5-flash",
      "gemini-1.0-pro"
    ],
    deepseek: [
      "deepseek-chat",
      "deepseek-coder",
      "deepseek-r1",
      "deepseek-v3"
    ]
  };

export  const getAgentTypeColorForEva = (type: AgentType | undefined) => {
  switch (type) {
    case AgentType.TIGA:
      return "blue";
    case AgentType.PLAN:
      return "orange";
    case AgentType.TISA_V2:
      return "teal";
    case AgentType.TISA_CONTEXTUALISATION:
      return "red";
    case AgentType.TISA_CHAT:
      return "green";
    case AgentType.TISA_SCENARIO:
      return "yellow";
    default:
      return "gray";
  }
};

export const getAgentTypeColorForDarwinEva = (type: DarwinAgentType | undefined) => {
  switch (type) {
    case DarwinAgentType.CUSTOM:
      return "blue";
    case DarwinAgentType.TREE_SCHEMA_AGENT:
      return "orange";
    case DarwinAgentType.MULTI_TREE_SCHEMA_AGENT:
      return "teal";
    case DarwinAgentType.ADD_NUMBERS_TOOL_AGENT:
      return "green";
    default:
      return "gray";
  }
};

export const getToolTypeColorForDarwinEva = (type: DarwinToolType | undefined) => {
  switch (type) {
    case DarwinToolType.AGENT_TOOL:
      return "blue";
    case DarwinToolType.ADD_NUMBERS:
      return "green";
    default:
      return "gray";
  }
};

export const usageExample = `You are {{agent_name}}, a specialized AI agent for {{agent_description}}.

Your objective is to {{objective}}.

Today's date: {{DATE}}
Company: {{COMPANY_NAME}}

{% if plan_name %}
Working with plan: {{plan_name}}
Description: {{plan_description}}
{% endif %}

{% if MKG_INFO %}
Metric Knowledge Graph Information:
{{MKG_INFO}}
{% endif %}

{% if ANALYSIS_TREES %}
Analysis Trees:
{{ANALYSIS_TREES}}
{% endif %}

Custom Instructions: {{custom_instructions}}
Key Issues to Address: {{key_issues}}`;
